import React, { useState, useEffect } from "react";
import "./Admission.css";
import studentImg from "../../assets/images/admission.jpg";
import { admissionStorage } from "../../utils/storage";

const Admission = () => {
  const [admissions, setAdmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAdmissions = async () => {
      try {
        const storedAdmissions = await admissionStorage.getAllAdmissions();
        setAdmissions(storedAdmissions);
        setLoading(false);
      } catch (error) {
        console.error('Error loading admissions:', error);
        setLoading(false);
      }
    };

    setTimeout(loadAdmissions, 500);

    // Listen for storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'alasar_admissions') {
        console.log('Admissions storage changed, reloading...');
        loadAdmissions();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  if (loading) {
    return (
      <div className="admission-wrapper">
        <section className="admission-news-section" style={{ backgroundImage: `url(${studentImg})` }}>
          <div className="news-overlay">
            <div className="admission-news-container">
              <div className="loading-spinner"></div>
              <p>Loading admissions...</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="admission-wrapper">
      {/* ===== Banner Section ===== */}
      {/* <section
        className="admission-banner"
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        <div className="banner-overlay">
          <h1>Admissions Open 2025</h1>
          <p>Your path to excellence starts here</p>
        </div>
      </section> */}

      {/* ===== Admission News Cards ===== */}
      <section
        className="admission-news-section"
        style={{ backgroundImage: `url(${studentImg})` }}
      >
        <div className="news-overlay">
          <div className="admission-news-container">
            <h2 className="news-title">Latest Admission Announcements</h2>
            <div className="admission-cards">
              {admissions.map((item, index) => (
                <div className="admission-card" key={item.id || index}>
                  {item.imageUrl && (
                    <div className="admission-card-image">
                      <img src={item.imageUrl} alt={item.title} />
                    </div>
                  )}
                  <div className="admission-card-content">
                    <div
                      className={`status-tag ${
                        item.status === "Open"
                          ? "open"
                          : item.status === "Upcoming"
                          ? "upcoming"
                          : "closed"
                      }`}
                    >
                      {item.status}
                    </div>
                    <h3>{item.title}</h3>
                    <p className="dates">
                      <strong>Start:</strong> {item.startDate ? new Date(item.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : item.startDate} <br />
                      <strong>End:</strong> {item.endDate ? new Date(item.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : item.endDate}
                    </p>
                    <p className="desc">{item.description}</p>
                    <a href={item.link} className="apply-btn">
                      Apply Now
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Admission;
